export const subtitles = {
    "1": {
        "startTime": 9.3,
        "endTime": 10.27,
        "transcript": "Tua-llu?",
        "translation": "Ready?"
    },
    "2": {
        "startTime": 11.12,
        "endTime": 23.1,
        "transcript": "Kitak' tayima qanruyutmek wall'u qaillun camek tayima paiciutmek...",
        "translation": "Now, [tell us] a piece of traditional wisdom, or something that you want to leave with us..."
    },
    "3": {
        "startTime": 23.475,
        "endTime": 29.375,
        "transcript": "Una wani aperciigatqala'arqa paiciluki.",
        "translation": "I have trouble saying the word \"paiciluki.\""
    },
    "4": {
        "startTime": 29.39,
        "endTime": 42.88,
        "transcript": "Paiciuten wani camek ataucimek elpeni arcaqalria irniarpenun wall'u canun yugnun tamaa-i umyuaqesqumakek'ngan qanrutkeqerru.",
        "translation": "Pleae talk about one thing that is important to you that you want to leave with your children, or something you want people to remember."
    },
    "5": {
        "startTime": 43.99,
        "endTime": 52.81,
        "transcript": "Tua-i-wa waniwa atauciq wangni angelriaruuq umyuaqesqumallra.",
        "translation": "Now, there is one thign that is important to me that I want you to remember."
    },
    "6": {
        "startTime": 52.815,
        "endTime": 59.665,
        "transcript": "Umyuaqesqumakumku waniwa elpet qanrucaramken",
        "translation": "If I want you to remember it, I would tell you now"
    },
    "7": {
        "startTime": 60.535,
        "endTime": 69.565,
        "transcript": "Atauciq waniwa una umyuaqerkan iciw' elluarrluten yuungnaqsukuvet:",
        "translation": "This is one thing you should remember, you know, if you want to live a good life:"
    },
    "8": {
        "startTime": 70.745,
        "endTime": 79.225,
        "transcript": "Elpenek ataneqerkaunrituten, temirteńgurrluteng-llu tuaten yuunge'rpet.",
        "translation": "You shall not be your own master, even if you live as an adult like that."
    },
    "9": {
        "startTime": 79.9,
        "endTime": 87.52,
        "transcript": "Umyuangqerrarkauguten, umyuarteqarkauguten camek ukvermek.",
        "translation": "You must have a mind, you must think of some belief."
    },
    "10": {
        "startTime": 89.745,
        "endTime": 95.855,
        "transcript": "Agayutem pisqutiinek ukvengqerrnarqaaten.",
        "translation": "You must believe in God's will."
    },
    "11": {
        "startTime": 97.265,
        "endTime": 109.335,
        "transcript": "Tua-llu pisciigalkuvgu tauna, Yupiim alerquutiinek cali ukvengqerrnarqaaten.",
        "translation": "Then if you can't do that, you must believe in Yup'ik instructions."
    },
    "12": {
        "startTime": 110.525,
        "endTime": 122.325,
        "transcript": "Tua-i-wa kiirrarpenek tuaten ukverraunak puqigyukluten elpenek, elpenek pirpakluten yuukuvet",
        "translation": "It's because if you live by yourself like that without faith, thinking you're smart, thinking highly of yourself"
    },
    "13": {
        "startTime": 122.82,
        "endTime": 126.8,
        "transcript": "Nalluaqa qaillun tayim' ayuqellerkan.",
        "translation": "I don't know how you'll end up."
    },
    "14": {
        "startTime": 126.812,
        "endTime": 135.712,
        "transcript": "Arcaqerluten tuaten taangatukuvet, qang'a-llu-qaa meluguallernek melutukuvet",
        "translation": "Especially if you drink alcohol like that, or even if you smoke marijuana"
    },
    "15": {
        "startTime": 135.719,
        "endTime": 143.494,
        "transcript": "Arcaqerluten qaillun, nalluaqa qaillun ayuqellerkan.",
        "translation": "Especially with you, I don't know how you'll end up."
    },
    "16": {
        "startTime": 143.5,
        "endTime": 149.675,
        "transcript": "Tau͡gken taukuk aipaagnek ukverluten yuukuvet",
        "translation": "However, if you live believing in one of those two"
    },
    "17": {
        "startTime": 149.744,
        "endTime": 161.781,
        "transcript": "Bible-aanek niitelten ukvekluki, agayutetangqellra nalluvkenaku ukvekluku",
        "translation": "Believing what you hear from the Bible, knowing and believing that there is a god"
    },
    "18": {
        "startTime": 161.794,
        "endTime": 171.331,
        "transcript": "Tuaten yuukuvet elperrarpenek piqataquvet, taumun tangvagtevnun nagciiquten.",
        "translation": "If you're going to live of your own accord like that, you will be hindered by the one who watches you."
    },
    "19": {
        "startTime": 172.456,
        "endTime": 182.744,
        "transcript": "Qang'a-llu-qaa tuaten tamatumek agayuvigmek piyunrilkuvet Yup'igtarmek qaneryaramek niitaqluten.",
        "translation": "But if you don't want to follow the church, listen to traditional Yup'ik wisdom."
    },
    "20": {
        "startTime": 182.757,
        "endTime": 187.319,
        "transcript": "Elpenek niitengnaqaqluten ukvekluki yuukuvet",
        "translation": "If you try to obey and believe them as you live"
    },
    "21": {
        "startTime": 187.337,
        "endTime": 202.774,
        "transcript": "Qaneryaraqlaqiit-llu tamakut Yupiit ca imna Cellam Yua alikluku takaqeqapiggluku, carrarmun tamalkuan pikestekniluku.",
        "translation": "And their traditional wisdom says that they revered the Spirit of the Universe, that [the Spirit] presided over everything"
    },
    "22": {
        "startTime": 202.787,
        "endTime": 209.087,
        "transcript": "Agayutmek-llu qanerpek'nateng, Cellam tau͡gaam Yuanek qanerluteng.",
        "translation": "And they didn't speak of God, but spoke of the Spirit of the Universe."
    },
    "23": {
        "startTime": 209.094,
        "endTime": 221.131,
        "transcript": "Iqlumek-llu tua-i-w' canek teguqautesqevkenaki-llu yuum nalluani.",
        "translation": "And of something wrong, they also said not to take anything that was not theirs behind a person."
    },
    "24": {
        "startTime": 221.806,
        "endTime": 227.544,
        "transcript": "Tauna-gguq assiilngurmun ayagiinarciquq tuaten ayuqellria.",
        "translation": "They said that one like that would get into worse things."
    },
    "25": {
        "startTime": 227.557,
        "endTime": 232.895,
        "transcript": "Iqluquyulria-llu-gguq cali assiilngurmun ayagiinarciquq.",
        "translation": "They also said that a liar would also get into worse things."
    },
    "26": {
        "startTime": 232.907,
        "endTime": 237.494,
        "transcript": "Tamakut tamaa-i Yupiit qaneryarait alingnarqellriit.",
        "translation": "That is traditional Yup'ik wisdom about what is dangerous."
    },
    "27": {
        "startTime": 237.957,
        "endTime": 245.844,
        "transcript": "Tua-i-gguq tau͡gken tuaten iqlumek pinritengnaqellria elluarrluni tua-i ciunerkaqegciluni-llu.",
        "translation": "However, they said that one who tried not to do wrong does well and has a good future."
    },
    "28": {
        "startTime": 245.862,
        "endTime": 252.899,
        "transcript": "Taumek cali ukvengqerquvet tuaten cali kayuluten yuuciquten.",
        "translation": "That's why if you live with faith, you will live with strength."
    },
    "29": {
        "startTime": 254.274,
        "endTime": 258.349,
        "transcript": "Tua-llu? (Yaa, quyana.) Ii-i. Cangata?",
        "translation": "So how was that? (Good, thank you.) Okay. How was it?"
    },
    "30": {
        "startTime": 259.38,
        "endTime": 263.88,
        "transcript": "Yuinaq-qaa cipingaat?",
        "translation": "Were they over 20?"
    },
    "31": {
        "startTime": 264.424,
        "endTime": 272.074,
        "transcript": "Nur'arcimaat, aa, cipingaat tua-i-wa yuinaq.",
        "translation": "A little short, uh, they wer over twenty."
    },
    "32": {
        "startTime": 274.318,
        "endTime": 278.618,
        "transcript": "Iluperangeksaunak-qaa? Iluperarluten-qaa?",
        "translation": "Haven't you had great-granchildren? Do you have great-grandchildren."
    },
    "33": {
        "startTime": 278.637,
        "endTime": 280.95,
        "transcript": "Malrugnek iluperangqertua.",
        "translation": "I have two great-granchildren."
    },
    "34": {
        "startTime": 280.962,
        "endTime": 285.112,
        "transcript": "Yaa, nani-llu yuurtellruluten?",
        "translation": "Okay, and where were you born?"
    },
    "35": {
        "startTime": 286.356,
        "endTime": 289.969,
        "transcript": "Sheldon's Point, Nunam Iquani.",
        "translation": "Sheldon's Point, at Nunam Iqua."
    },
    "36": {
        "startTime": 289.981,
        "endTime": 292.431,
        "transcript": "Wani Kuigpiim paingani.",
        "translation": "Here at the mouth of the Yukon."
    },
    "37": {
        "startTime": 293.4,
        "endTime": 295.625,
        "transcript": "Qangvaq-mi...",
        "translation": "So, when..."
    },
    "38": {
        "startTime": 297.019,
        "endTime": 306.356,
        "transcript": "Tua-i-w', tua-i-w' pillilrianga. Imna cikiuteka lifetime certificate-aqa cali avaqliqkeka.",
        "translation": "I probably am. I still have the lifetime certificate that I got."
    },
    "39": {
        "startTime": 307.669,
        "endTime": 313.631,
        "transcript": "Iciw' nasvaumaluku pimanrituq.",
        "translation": "You know, it's not shown."
    },
    "40": {
        "startTime": 313.644,
        "endTime": 321.369,
        "transcript": "Tau͡gaam iciw' kia piqa'arqanga tua-i ava-i qanllemtun kia piqa'arqanga tua-i ikayuutengnaqsartua.",
        "translation": "But, you know, when someone asks me, as I said, when someone asks me, I'd try to help."
    },
    "41": {
        "startTime": 321.375,
        "endTime": 332.788,
        "transcript": "Makunun tuaten cali maani avani tuaten pilrianun [?] piyunarqaqama ullauteqerlartua.",
        "translation": "Even to the people here who are like that around me, [?] when I can, I go to them."
    },
    "42": {
        "startTime": 333.975,
        "endTime": 337.288,
        "transcript": "Yaa, amllerillilria-wa.",
        "translation": "Okay, that's probably enough."
    },
    "43": {
        "startTime": 337.45,
        "endTime": 340.025,
        "transcript": "Cali? (Mhm.) Okay.",
        "translation": "More? (Mhm.) Okay."
    },
    "44": {
        "startTime": 342.831,
        "endTime": 352.269,
        "transcript": "Qanertuńgulartuten kelgumaaqavet maani, YKHC-rmiut call' cali workshop-arqameng kelgaqluten.",
        "translation": "You are a speaker when invited here, and YKHC also invites you when they have workshops."
    },
    "45": {
        "startTime": 352.282,
        "endTime": 356.457,
        "transcript": "Tamakut, tuaten-qaa cali active-aartuten?",
        "translation": "With those, are you still active?"
    },
    "46": {
        "startTime": 356.463,
        "endTime": 362.088,
        "transcript": "Keleksailatnga wavet YKCH-mun qangvarnek",
        "translation": "Since they didn't invite me here to YKHC"
    },
    "47": {
        "startTime": 362.607,
        "endTime": 366.569,
        "transcript": "Three years-aqatarngatuq waniw' kellgaanratnek.",
        "translation": "I think it's going to be three years since they've invited me."
    },
    "48": {
        "startTime": 366.807,
        "endTime": 372.182,
        "transcript": "Piksailatnga piksaitua. News-amun tau͡gaam pillruunga wangnek.",
        "translation": "Since they didn't, I didn't go. But I did go on the news by myself."
    },
    "49": {
        "startTime": 372.738,
        "endTime": 374.563,
        "transcript": "Malrurqugnek-llu pillilrianga.",
        "translation": "I've probably gone twice."
    },
    "50": {
        "startTime": 374.619,
        "endTime": 379.994,
        "transcript": "Ataucimek cali maani ik'um KCC-m pillrani...",
        "translation": "And once here, when KCC across there had an event..."
    }
};